import {
  getAnalytics,
  logEvent,
  setUserId as setUser,
  setUserProperties,
  Analytics as AnalyticsType,
} from 'firebase/analytics';
import SayKitWeb from '@whitesharx/starfall-frontend-saykit-web';
import { FirebaseApp } from 'firebase/app';
import GoogleConversion, { MAIN_TO_GOOGLE_CONVERSION_EVENTS } from './google-conversion';
import FacebookConversion, { MAIN_TO_FACEBOOK_CONVERSION_EVENTS } from './facebook-conversion';
import { AbstractAnalytics, EventParamsType } from './type';
import { MAIN_TO_SAYKIT_EVENTS } from './contants';

type EventsQueueType = {
  name: string;
  params?: EventParamsType;
};

class Analytics implements AbstractAnalytics {
  private queue: EventsQueueType[] = [];
  private initialized = false;
  private instance: AnalyticsType | null = null;
  private googleConversion = new GoogleConversion();
  private facebookConversion = new FacebookConversion();
  public userId: string | null = null;

  constructor(private firebase?: FirebaseApp) {}

  public load() {
    if (this.firebase) {
      this.instance = getAnalytics(this.firebase);

      setUserProperties(this.instance, { keyword_ab_test_group: SayKitWeb.featureFlags.keyword_ab_test_group });
    }

    this.initialized = true;

    if (this.queue.length > 0) {
      this.queue.forEach((event) => {
        this.sendEvent(event.name, event.params);
      });
    }

    if (this.instance && this.userId) {
      setUser(this.instance, this.userId);
    }
  }

  public sendEvent(name: string, params?: EventParamsType) {
    if (!this.initialized) {
      this.queue.push({ name, params });

      return;
    }

    if (process.env.ANALYTICS_ENABLED) {
      if (this.instance) {
        logEvent(this.instance, name, params);
      }

      const saykitEvent = MAIN_TO_SAYKIT_EVENTS[name];
      if (saykitEvent) {
        const { event, ...rest } = saykitEvent(params);

        SayKitWeb.trackEvent(event, { ...rest });
      }

      const googleConversionEvent = MAIN_TO_GOOGLE_CONVERSION_EVENTS[name];
      if (googleConversionEvent) {
        this.googleConversion.trackEvent(googleConversionEvent);
      }
      const facebookConversionEvent = MAIN_TO_FACEBOOK_CONVERSION_EVENTS[name];

      if (facebookConversionEvent) {
        this.facebookConversion.trackEvent(facebookConversionEvent);
      }
    } else {
      console.log(name, params);
    }
  }

  public setUserId(id: string) {
    if (this.instance) {
      setUser(this.instance, id);
    }

    this.userId = id;
  }
}

export default Analytics;
